import styled from "styled-components";
import Box from "../../../elements/v2/Box/Box";

export const Section = styled(Box).attrs({
  as: "section",
})`
  margin: 0 auto;
  max-width: 380px;
`;
